import { render, staticRenderFns } from "./pushchanneltable.vue?vue&type=template&id=27a5b614&scoped=true&"
import script from "./pushchanneltable.vue?vue&type=script&lang=js&"
export * from "./pushchanneltable.vue?vue&type=script&lang=js&"
import style0 from "./pushchanneltable.vue?vue&type=style&index=0&id=27a5b614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5b614",
  null
  
)

export default component.exports